import Axios from "axios";
import {
  SET_DYEING_ORDER_LIST,
  UNSET_DYEING_ORDER_LIST,
} from "@/store/mutation-types";

import { dyeingOrderResource } from "@/store/api";

const state = {
  getDyeingOrderList: [],
};

const getters = {
  getDyeingOrderList(state) {
    return state.getDyeingOrderList;
  },
};

const mutations = {
  [SET_DYEING_ORDER_LIST](state, data) {
    state.getDyeingOrderList = data;
  },
  [UNSET_DYEING_ORDER_LIST](state) {
    state.getDyeingOrderList = [];
  },
};

const actions = {

    getDyeingOrderList({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
        Axios.get(dyeingOrderResource, { params })
            .then((response) => {
            commit(SET_DYEING_ORDER_LIST, response.data.data);
            resolve(response);
            })
            .catch((error) => {
            commit(UNSET_DYEING_ORDER_LIST);
            reject(error);
            });
        });
    },

    saveDyeingOrder({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });

        return new Promise((resolve, reject) => {
        Axios.post(dyeingOrderResource, data)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

    updateDyeingOrder({ commit }, { id, data }) {
        commit("SET_LOADING", { color: "primary" });

        const url = `${dyeingOrderResource}/${id}`;

        return new Promise((resolve, reject) => {
        Axios.put(url, data)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

    getDyeingOrderById({ commit }, { id }) {
        commit("SET_LOADING", { color: "primary" });
        const url = `${dyeingOrderResource}/${id}`;
        return new Promise((resolve, reject) => {
        Axios.get(url)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

};

export default {
  state,
  getters,
  actions,
  mutations,
};

